var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.ad80a711be9803157c281838ea39aec3.svg#h';
                    var viewUrl = 'sprites.ad80a711be9803157c281838ea39aec3.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };